// Software built by  Adeweb Developer Africa
// portfolio website: https://adeweb-developer.vercel.app
// whatsApp Message: https://wa.me/23407043455416
// I am open for your software development gig, thank you

import React, { useState, useEffect } from "react";
import { auth, googleProvider } from "../../firebase";
import { createUserWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { doc, setDoc } from "firebase/firestore";
import { db } from "../../firebase";
import "./Signup.css";
import NameIcon from "../../assets/UserIcon.svg";
import Emailicon from "../../assets/emailShape.svg";
import UserOne from "../../assets/OnboardingCards/IMG_7252.JPG";
import UserTwo from "../../assets/OnboardingCards/IMG_7250.JPG";
import UserThree from "../../assets/OnboardingCards/IMG_7255.JPG";
import PasswordIcon from "../../assets/passwordIcon.svg";
import Facebook from "../../assets/OnboardingCards/FacebookBlue.svg";
import Google from "../../assets/OnboardingCards/GoogleColor.svg";
import CheckIt from "../../assets/checkit.svg";
import IkoroduLogo from "../../assets/OnboardingCards/Ikorodu-Dating-Logo.svg";
import FirstHook from "../../assets/IMG_2166.JPG";
import FirstHooks from "../../assets/IMG_2173.JPG";
import FirstHookd from "../../assets/IMG_2167.JPG";
import FirstHookf from "../../assets/IMG_2169.JPG";
import FirstHookh from "../../assets/IMG_2170.JPG";
import { FiZap, FiUserCheck, FiMapPin, FiShield } from "react-icons/fi";

const Signup = () => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 668);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 668); // Check if screen width is mobile size
    };

    window.addEventListener("resize", handleResize); // Listen for resize events
    return () => {
      window.removeEventListener("resize", handleResize); // Cleanup
    };
  }, []);

  if (!isMobile) {
    return (
      <div className="isNotMobile" style={{ padding: 20, textAlign: "center" }}>
        <h2>
          This Dating Site is a Web App is best viewed on a mobile device.
        </h2>
        <p>
          Please switch to a mobile device or adjust your browser window size,
          thank you
        </p>
      </div>
    );
  }

  const handleEmailSignup = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    setLoading(true); // We set loading to true when sign up start

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );
      await setDoc(doc(db, "users", userCredential.user.uid), {
        firstName,
        lastName,
        email,
        phone,
        messages: [],
        statuses: [],
        role: "user",
        status: "pending",
        createdAt: new Date(),
      });
      navigate("/profile-picture-setup");
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-container">
      <div className="onboardingBackBTN">
        <div className="authTextBox">
          <img style={{ width: 44 }} src={IkoroduLogo} alt="back button" />
          <h2 className="authText">Ikorodu Dating Site</h2>
        </div>

        <div></div>
      </div>

      <div className="signUpTop">
        <div className="signUpTopH">
          <h2>Sign Up</h2>
          <p style={{ fontSize: 10, color: "#00000080" }}>
            We can't wait to have you onboard, there are some beautiful ladies
            and handsome guys already on our site.
          </p>
        </div>

        <div className="userOnlineHolder">
          <div className="usersOnline">
            <img className="usersOnline" src={UserOne} alt="user online" />
          </div>
          <div className="usersOnline">
            <img className="usersOnline" src={UserTwo} alt="user online" />
          </div>
          <div className="usersOnline">
            <img className="usersOnline" src={UserThree} alt="user online" />
          </div>
        </div>
      </div>
      {error && (
        <p
          style={{
            marginBottom: "20px",
          }}
        >
          {error}
        </p>
      )}
      <form className="signup-form" onSubmit={handleEmailSignup}>
        <div className="signMeUp">
          <p className="signUp-info">First name</p>
        </div>
        <div className="signUpHolder">
          <img src={NameIcon} alt="first name icon" />
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
        </div>
        <div className="signMeUp">
          <p className="signUp-info">Last name</p>
        </div>
        <div className="signUpHolder">
          <img src={NameIcon} alt="last name icon" />
          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
        </div>
        <div className="signMeUp">
          <p className="signUp-info">Whatsapp Number</p>
        </div>
        <div className="signUpHolder">
          <img src={Emailicon} alt="email icon" />
          <input
            type="number"
            placeholder="phone number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />
        </div>
        <div className="signMeUp">
          <p className="signUp-info">Email</p>
        </div>
        <div className="signUpHolder">
          <img src={Emailicon} alt="email icon" />
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="signMeUp">
          <p className="signUp-info">Password</p>
        </div>
        <div className="signUpHolder">
          <img src={PasswordIcon} alt="password icon" />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="signMeUp">
          <p className="signUp-info">Confirm Password</p>
        </div>
        <div className="signUpHolder">
          <img src={PasswordIcon} alt="confirm password icon" />
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <div className="termsText">
          <img src={CheckIt} alt="Accept terms" />I agree with the terms and
          condition of Ikorodu dating site, by signing up for an account
        </div>

        <button className="submit-Btn" type="submit" disabled={loading}>
          {loading ? <span className="loaderr"></span> : "Sign Up"}
        </button>
        <div className="orDesign">
          --------- or you're already a member -----------
        </div>

        {/* <div className="GoogleHolder">
          <button
            className="google-Btn"
            onClick={handleGoogleSignup}
            disabled={loading}
          >
            <img src={Google} alt="Google sign up" />
          </button>

          <button
            className="google-Btn"
            onClick={handleGoogleSignup}
            disabled={loading}
          >
            <img src={Facebook} alt="Facebook sign up" />
          </button>
        </div> */}

        <button onClick={() => navigate("/login")} className="faed">
          Please{" "}
          <span
            style={{ color: "#e91e63", fontSize: "17px", fontWeight: "600" }}
          >
            Login here
          </span>
        </button>

        <div
          style={{
            width: "95%",
            marginTop: "5%",
          }}
          className="sectionfront"
        >
          <div className="oldtext">
            <h1>No Games. Just Connections.</h1>

            <p>
              Tired of the endless "what are we?" talk? We get it. Sometimes you
              just want to skip the small talk and find someone who is on the
              exact same page as you.
            </p>

            <div className="benefits-grid">
              <div className="benefit-item">
                <FiZap className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Zero Pressure</h3>
                  <p>
                    This is a judgment-free zone. State your intentions upfront
                    and find others doing the same.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiUserCheck className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Verified Profiles</h3>
                  <p>
                    We prioritize real people. Our verification process ensures
                    who you see is who you meet.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiMapPin className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Local & Ready</h3>
                  <p>
                    Find active members in Ikorodu who aren't looking to waste
                    time.
                  </p>
                </div>
              </div>

              <div className="benefit-item">
                <FiShield className="benefit-icon" />
                <div className="benefit-text">
                  <h3>Total Privacy</h3>
                  <p>
                    Your business is yours. Encrypted messaging keeps your
                    conversations discreet.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="hooksBoxx">
            <div
              style={{
                width: "100%",
                marginTop: "0.2rem",
                marginBottom: "1rem",
              }}
              className="bentoGrid"
            >
              {isMobile ? (
                <div className="bentoTop">
                  <div className="bentotopone">
                    <div className="bentoChild">
                      <img
                        src={FirstHook}
                        alt="Casual Connection"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>No Strings Attached</h3>
                      </div>
                    </div>

                    <div className="bentoChild">
                      <img
                        src={FirstHooks}
                        alt="Verified"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>100% Verified</h3>
                      </div>
                    </div>
                  </div>
                  <div className="bentotoptwo">
                    <div className="bentoChild">
                      <img src={FirstHookd} alt="Local" className="bentoImg" />
                      <div className="bentoOverlay">
                        <h3>Right Near You</h3>
                      </div>
                    </div>

                    <div className="bentoChild">
                      <img
                        src={FirstHookf}
                        alt="Discreet"
                        className="bentoImg"
                      />
                      <div className="bentoOverlay">
                        <h3>Total Privacy</h3>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bentoTop">
                  <div className="bentoChild">
                    <img
                      src={FirstHook}
                      alt="Casual Connection"
                      className="bentoImg"
                    />
                    <div className="bentoOverlay">
                      <h3>No Strings Attached</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHooks} alt="Verified" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>100% Verified</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHookd} alt="Local" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>Right Near You</h3>
                    </div>
                  </div>

                  <div className="bentoChild">
                    <img src={FirstHookf} alt="Discreet" className="bentoImg" />
                    <div className="bentoOverlay">
                      <h3>Total Privacy</h3>
                    </div>
                  </div>
                </div>
              )}
              <div
                style={{
                  overflow: "hidden",
                  height: "450px",
                }}
                className="bentoBottom"
              >
                <img src={FirstHookh} alt="Discreet" className="bentoImg" />
                <div className="bentoOverlay">
                  <h3
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Find active members in Ikorodu ready to meet now.
                  </h3>
                  <p
                    style={{
                      color: "#ffffff90",
                      fontWeight: "500",
                    }}
                  >
                    Encrypted messaging to keep your business your business.
                  </p>
                  <p
                    style={{
                      color: "#ffffff90",
                      fontWeight: "500",
                    }}
                  >
                    We prioritize real people so who you see is who you meet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Signup;
